import { render, staticRenderFns } from "./MyHistory.vue?vue&type=template&id=2ceb8fa3&scoped=true"
import script from "./MyHistory.vue?vue&type=script&lang=js"
export * from "./MyHistory.vue?vue&type=script&lang=js"
import style0 from "./MyHistory.vue?vue&type=style&index=0&id=2ceb8fa3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ceb8fa3",
  null
  
)

export default component.exports